(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/shared-components/scam-warning.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/shared-components/scam-warning.js');
'use strict';

const HREF = 'https://om.svenskaspel.se/bedragerier-allt-vanligare-var-pa-din-vakt/';
const ScamWarning = () => {
  const fontColor = ReactRedux.useSelector(state => state.playerloginreact.theme.fontColor);
  const handleClick = e => {
    e.preventDefault();
    svs.components.analytics.trackEvent({
      category: 'Users',
      action: 'Login Failure',
      opt_label: 'Logg_in_own_initiativ_readmore'
    }, () => {
      svs.utils.url.navigate(HREF);
    });
  };
  return React.createElement("p", {
    className: "margin-top-1 margin-bottom-0"
  }, React.createElement("a", {
    className: "u-text-decoration-underline ".concat(fontColor),
    href: HREF,
    onClick: handleClick
  }, "L\xE4s mer om hur du loggar in s\xE4kert"));
};
svs.playerLoginReact.sharedComponents.ScamWarning = ScamWarning;

 })(window);